import ko from "knockout";
import filterContainerViewModel from "flow/filter/FilterContainerComponent/filterContainerViewModel";
import filterContainerHtml from "flow/filter/FilterContainerComponent/FilterContainer.html";

function setup() {
    ko.components.register("filter-container", {
        viewModel: filterContainerViewModel,
        template: filterContainerHtml
    });
}

export default {
    setup: setup
};
